import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.615 1.597a.75.75 0 0 1 .359.853l-1.992 7.302h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.709l1.992-7.303H3.75a.75.75 0 0 1-.548-1.261l10.5-11.25a.75.75 0 0 1 .913-.144"
    }, null, -1)
  ])))
}
export default { render: render }